// extracted by mini-css-extract-plugin
export default {"wrapper":"Template_wrapper__Z7fNP"};